<div
  #cardRoot
  class="card division-chart-card"
  *ngIf="data"
>
  <div class="card-header division-chart-header">
    <div class="card-title title-block">
      <h4>{{ currentTitle }}</h4>
      <p *ngIf="currentSubtitle">{{ currentSubtitle }}</p>
    </div>

    <div class="view-tabs" *ngIf="viewTabs.length > 1" role="tablist" aria-label="Chart views">
      <button
        type="button"
        *ngFor="let tab of viewTabs; let index = index"
        class="view-tab"
        [class.active]="index === activeViewIndex"
        (click)="selectView(index)"
      >
        {{ tab.label }}
      </button>
    </div>
  </div>

  <div class="chart-shell">
    <div
      #plotScroll
      class="plot-scroll"
      [class.fit-to-width]="fitToWidth"
      [style.--plot-min-width.px]="plotMinWidth"
      [style.--category-area-width.px]="categoryAreaWidth"
      [style.--division-label-width.px]="divisionLabelWidth"
      [style.--grid-right-width.px]="gridRightWidth"
    >
      <div #chartHost class="chart-host"></div>

      <div class="division-table" *ngIf="divisionRows.length && categoryCount > 0">
        <div class="division-row" *ngFor="let row of divisionRows">
          <div class="division-label">{{ row.label }}</div>
          <div class="division-track" [style.grid-template-columns]="divisionGridTemplate">
            <div
              *ngFor="let segment of row.segments"
              class="division-cell"
              [class.compact]="segment.compact"
              [style.grid-column]="segment.gridColumn"
              [title]="segment.label"
              role="button"
              tabindex="0"
              (click)="onDivisionSegmentClick(row, segment)"
              (keydown.enter)="onDivisionSegmentClick(row, segment)"
              (keydown.space)="onDivisionSegmentClick(row, segment); $event.preventDefault()"
            >
              <span class="division-cell-label">{{ segment.label }}</span>
            </div>
          </div>
          <div class="division-end-spacer"></div>
        </div>
      </div>
    </div>
  </div>
</div>
